// extracted by mini-css-extract-plugin
export var image = "cw_dj";